<template>
    <div class="driver-list">
        <HeaderNav
            header-title="选择车辆"
            left-icon-name=""
            right-icon-name=""
        ></HeaderNav>
        <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
        <div class="driver-wrapper" :class="{ 'no_data': isActive }">
            <p class="warning">
                注：务必输入司机和车辆信息，以免车辆无法入场
            </p>
            <ul class="driver-box">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finishedText"
                    :immediate-check="false"
                    :error.sync="error"
                    :error-text="errorText"
                    @load="onLoad"
                >
                    <div
                        class="driver-item"
                        v-for="(item, index) in materialPlanList"
                        :key="item.id"
                    >
                        <van-row>
                            <van-col span="4">
                                <div class="driver-radio">
                                    <input
                                        type="checkbox"
                                        name="name"
                                        :id="item.id"
                                        :value="item.id"
                                        v-model="CheckedArr"
                                        @change="handleChange()"
                                    >
                                    <label :for="item.id">
                                        <i v-if="!CheckedArr.includes(item.id)" class="iconfont iconunselect-radio2"></i>
                                        <i v-if="CheckedArr.includes(item.id)" class="iconfont iconxuanzhong"></i>
                                    </label>
                                </div>
                            </van-col>
                            <van-col span="10">
                                <div class="driver-msg">
                                    <p class="platenumber">
                                        {{ item.car_no }}
                                    </p>
                                    <p class="name">
                                        {{ item.driver_name }}
                                    </p>
                                </div>
                            </van-col>
                            <van-col span="10">
                                <div class="driver-edit-wrapper">
                                    <p class="edit-btn" @click="deleteClick(item, index)">
                                        删除
                                    </p>
                                    <p class="phone">
                                        {{ item.driver_phone }}
                                    </p>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </van-list>
            </ul>
            <div class="btn-wrapper">
                <div class="driver-radio van_left">
                    <input
                        type="checkbox"
                        name="name"
                        v-model="isSelectAll"
                    >
                    <label @click="selectAll()">
                        <i v-if="isSelectAll == false" class="iconfont iconunselect-radio2"></i>
                        <i v-if="isSelectAll == true" class="iconfont iconxuanzhong"></i>
                    </label>
                </div>
                <van-button
                    class="van_right"
                    type="danger"
                    :disabled="CheckedArr.length<=0"
                    @click="supplierSubmitCar"
                >
                    完成
                </van-button>
            </div>
        </div>
        <span class="add-btn" @click="btnClick('driverAdd')"><i class="iconfont iconicon-test"></i></span>
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            // 搜索字段
            value: '',
            materialPlanList: [],
            loading: true,
            finished: false,
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            // 已选
            selectCheckedArr: [],
            CheckedArr: [],
            isActive: false,
            error: false,
            errorText: '',
            finishedText: '没有更多了',
            formData: {},
            // 是否全选
            isSelectAll: false,
        };
    },
    created() {
        this.formData = JSON.parse(this.$route.query.row);
        this.getList();
        if (JSON.parse(this.$route.query.CheckedArr)) {
            this.selectCheckedArr = JSON.parse(this.$route.query.CheckedArr);
            this.CheckedArr = JSON.parse(JSON.stringify( this.selectCheckedArr ));
        }
    },
    watch: {},
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'FeedbackSubmit', query: { row: JSON.stringify(this.formData) } });
        },
        supplierSubmitCar() {
            const CheckedArr = [];
            this.CheckedArr.forEach(element => {
                this.materialPlanList.forEach(item => {
                    if (item.id === element) {
                        CheckedArr.push(item.id);
                    }
                });
            });
            if (CheckedArr.length === 0) {
                this.$toast('请选择车辆');
                return;
            }
            this.$axios
                .put(`/interfaceApi/procurement/daily/supply/truck/add/${this.formData.id}/${CheckedArr}`)
                .then(async res => {
                    this.$toast(res);
                    this.$router.isBack = 1;
                    this.$router.replace({ name: 'FeedbackSubmit', query: { row: JSON.stringify(this.formData) } });
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 检查是否满足同步车辆且同步车辆
        async checkSyncCars(carIds = []) {
            try {
                const count = await this.$axios.get('/interfaceApi/procurement/daily/supply/get_supply_match_count/' + this.formData.id);
                if (count >= 2 ) {
                    const cfmFlag = await this.$dialog.confirm({
                        title: '是否同步',
                        message: '是否将该车辆同步到其他供应单？',
                        confirmButtonText: '同步',
                    });
                    if (cfmFlag === 'confirm') {
                        // 执行同步
                        this.$toast.loading({
                            message: '同步中...',
                            forbidClick: true,
                            duration: 0,
                        });
                        const syscResult = await this.$axios.put('/interfaceApi/procurement/daily/supply/truck/matchadd', {
                            id: this.formData.id,
                            carids: carIds.join(),
                        });
                        this.$toast.clear();
                        if (syscResult) {
                            this.$toast.success('同步成功');
                        }
                    }
                }
            } catch (error) {
                if (error.ErrorCode) {
                    this.$dialog({ message: error.ErrorCode.Message });
                }
            }
        },
        handleChange() {
            // this.materialPlanList.forEach(item => {
            //     this.CheckedArr.push(item.id);
            // });
        },
        onLoad() {
            setTimeout(() => {
                this.page.pageindex += 1;
                this.getList();
            }, 200);
        },
        btnClick(name, item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: name,
                query: {
                    state: JSON.stringify(item),
                    row: JSON.stringify(this.formData),
                    CheckedArr: JSON.stringify(this.CheckedArr),
                },
            });
        },
        // 删除
        deleteClick(data, index) {
            this.$axios
                .get(`/interfaceApi/procurement/truck/deletetrucks/${data.id}`)
                .then(() => {
                    this.materialPlanList.splice(index, 1);
                    this.$toast.success({
                        message: '删除成功',
                        duration: 500,
                    });
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        getList() {
            let url = `/interfaceApi/procurement/daily/supply/get_choose_truck_page/${this.formData.id}?pageindex=`;
            if (this.formData.transport_type === 0) {
                url += this.page.pageindex + '&pagesize='
                 + this.page.pagesize + '&supplier_id='
                 + this.formData.supplier_id + '&searchKey='
                 + this.value;
            } else {
                url += this.page.pageindex + '&pagesize='
                 + this.page.pagesize + '&transport_id='
                 + this.formData.transport_id + '&searchKey='
                 + this.value;
            }
            this.$axios
                .get(url)
                .then(res => {
                    this.loading = false;
                    this.materialPlanList.push(...res.rows);

                    const selectedData = this.materialPlanList.filter(item => this.CheckedArr.indexOf(item.id) > -1);
                    if (this.materialPlanList.length > selectedData.length) {
                        this.isSelectAll = false;
                    } else {
                        this.isSelectAll = true;
                    }

                    if (this.materialPlanList.length >= res.total) {
                        this.finished = true;
                    }
                    if (this.materialPlanList.length === 0 ) {
                        this.finishedText = '';
                        this.isActive = true;
                        this.finished = true;
                    } else {
                        this.isActive = false;
                    }
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
        // 查询
        search() {
            this.page.pageindex = 1;
            this.materialPlanList = [];
            this.CheckedArr = [];
            this.CheckedArr = JSON.parse(JSON.stringify( this.selectCheckedArr ));
            this.finished = false;
            this.getList();
        },
        // 全选
        selectAll() {
            this.CheckedArr = [];
            if (this.isSelectAll === false) {
                this.isSelectAll = true;
                this.materialPlanList.forEach(item => {
                    this.CheckedArr.push(item.id);
                });
            } else {
                this.isSelectAll = false;
            }
        },
    },
};
</script>

<style lang="stylus">
.driver-list
    padding-top 44rpx
    height calc(100% - 44rpx)
    background #ffffff
    position relative
    .add-btn
        position absolute
        top 15rpx
        right 15rpx
        color #fff
        font-size 16rpx
        z-index 999
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .driver-wrapper
        height calc(100% - 44rpx)
        overflow-y auto
        overflow-x hidden
        padding-bottom 60rpx
        .driver-radio
            text-align center
            color #3396FB
            line-height 45rpx
            font-size 22rpx
            font-weight 600
            input
                display none
                opacity 0
        &.no_data
            background url(./../../assets/images/addressBook/no_address_book@2x.png) left center no-repeat
            background-size contain
        .warning
            width 100%
            height 30rpx
            line-height 30rpx
            background rgba(254,229,229,1)
            color #E60000
            text-align center
            font-size 12rpx
        .driver-box
            flex 1
            width 100%
            background #ffffff
            .driver-item
                padding 10rpx 15rpx 10rpx 0
                border-bottom 2rpx solid rgba(240,240,240,1)
                .driver-msg
                    p
                        height 24rpx
                        line-height 24rpx
                    .platenumber
                        font-size 16rpx
                        color #061F3E
                        font-weight 400
                    .name
                        font-size 14rpx
                        color #666666
                .driver-edit-wrapper
                    text-align right
                    p
                        height 24rpx
                        line-height 24rpx
                    .edit-btn
                        font-size 12rpx
                        color #0189FC
                        display inline-block
                    .phone
                        font-size 14rpx
                        color #979EA7
        .btn-wrapper
            width 100%
            position fixed
            left 0
            bottom 0
            background #ffffff
            border-top 2rpx solid rgba(240,240,240,1)
            height 60rpx
            .driver-radio
                width 17%
                line-height 60rpx
            .van-button
                width 150rpx
                height 42rpx
                margin 9rpx 20rpx
                border-radius 21rpx
</style>
